import { Injectable } from '@angular/core';
import { fixedArrayCache } from '@common/helper';
import { OfficeAllData } from '@common/interfaces';
import { SupportClass } from '@lib/components/support-class';
import { AswMasterService, CommonLibService } from '@lib/services';
import { getOfficeAllMasterKey } from './temporary-url-modal.state';

/**
 * 一時URL表示モーダル用サービス
 */
@Injectable({
  providedIn: 'root',
})
export class TemporaryUrlModalService extends SupportClass {
  constructor(private _common: CommonLibService, private _aswMasterService: AswMasterService) {
    super();
  }

  /**
   * クエリパラメータ付加処理
   * ※一時URLは他ユーザと共有可能なため、付加すべきパラメータが通常のリンクと異なる
   * @param url クエリパラメータを付加するURL
   * @param nextEvent
   */
  addQueryParamsNext(url: string, nextEvent: (urlWithParams: string) => void): void {
    // CONNECTION_KIND取得用にキャッシュ読み込み
    this._getOfficeAllNext((officeAll) => {
      const aswContext = this._common.aswContextStoreService.aswContextData;
      const connectionKind =
        officeAll.find((office) => office.office_code === aswContext.pointOfSaleId)?.connection_kind ?? '';

      // URLを構成
      const newUrl = new URL(url);
      newUrl.searchParams.set('CONNECTION_KIND', connectionKind);
      newUrl.searchParams.set('LANG', aswContext.lang);

      nextEvent(newUrl.toString());
    });
  }

  /**
   * オフィス_全リストを取得しコールバック関数に渡す
   * @param nextEvent 後続処理
   */
  private _getOfficeAllNext(nextEvent: (data: Array<OfficeAllData>) => void): void {
    this.subscribeService(
      'TemporaryUrlModal OfficeAll',
      this._aswMasterService.load(getOfficeAllMasterKey, true),
      ([data]) => {
        this.deleteSubscription('TemporaryUrlModal OfficeAll');
        nextEvent(fixedArrayCache(data));
      }
    );
  }

  destroy(): void {}
}
